import React from "react";
import { IoPlayCircle, IoPlayCircleOutline } from "react-icons/io5";
import NavButton from "./NavButton";

interface FeedButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const FeedButton: React.FC<FeedButtonProps> = ({ isActive, onClick }) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      // iOS ref: play.circle / play.circle.fill (_layout.tsx:68).
      // IoPlayCircle's filled form is a triangle KNOCKED OUT of a filled
      // circle — i.e. a tinted play triangle inside a circle, like the SF
      // Symbol. Do NOT use lucide PlayCircle + fill-current: that fills the
      // whole outer circle solid and hides the triangle.
      icon={<IoPlayCircleOutline className="h-full w-auto" />}
      fillIcon={<IoPlayCircle className="h-full w-auto" />}
      text="Feed"
    />
  );
};

export default FeedButton;
